import React from "react";

const TellaIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_962)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_2785_962)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.8 0H1.2C0.537258 0 0 0.537258 0 1.2V38.8C0 39.4627 0.537258 40 1.2 40H38.8C39.4627 40 40 39.4627 40 38.8V1.2C40 0.537258 39.4627 0 38.8 0Z",
  fill: "#7D83FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.8106 21.52H22.72C22.0573 21.52 21.52 22.0573 21.52 22.72V34.8106C21.52 35.4733 22.0573 36.0106 22.72 36.0106H34.8106C35.4733 36.0106 36.0106 35.4733 36.0106 34.8106V22.72C36.0106 22.0573 35.4733 21.52 34.8106 21.52Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 22.2944C3.99995 21.6992 4.7319 21.3271 5.3175 21.6247L18.0513 28.0948C18.6369 28.3924 18.637 29.1363 18.0514 29.434L5.31874 35.9058C4.73318 36.2035 4.00117 35.8315 4.00112 35.2364L4 22.2944Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2453 18.4906C15.2467 18.4906 18.4906 15.2467 18.4906 11.2453C18.4906 7.24382 15.2467 4 11.2453 4C7.24382 4 4 7.24382 4 11.2453C4 15.2467 7.24382 18.4906 11.2453 18.4906Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.6068 4H34.9238C35.524 4 36.0106 4.48658 36.0106 5.08679V6.53585C36.0106 7.13606 35.524 7.62264 34.9238 7.62264H30.5766V17.4038C30.5766 18.004 30.09 18.4906 29.4899 18.4906H28.0407C27.4406 18.4906 26.9539 18.004 26.9539 17.4038V7.62264H22.6068C22.0066 7.62264 21.52 7.13606 21.52 6.53585V5.08679C21.52 4.48658 22.0066 4 22.6068 4Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_962"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_2785_962"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(TellaIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;